export default __webpack_public_path__ + "e356cb0bf8d2b595f5b16333319c7bae.png";